$('a[href^="#"]').on('click', function(e) {
  var target = $(this).attr('href');
  // Exclude links that are just "#"
  if (target.length > 1 && $(target).length) {
    e.preventDefault();
    var offset = $(target).offset().top-70;
    $('html, body').animate(
      { scrollTop: offset },
      700 // duration in ms
    );
  }
});